module.exports = __webpack_public_path__ + "static/media/logo-pin.31c23e4d.svg";